import React from 'react'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#f5e6d3' }}>
      <div className="text-center px-4">
        <div className="mb-8">
          <h1 className="text-8xl md:text-9xl font-bold text-gray-300 mb-4">404</h1>
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-700 mb-2">Page Not Found</h2>
          <p className="text-gray-600 text-lg mb-8 max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        
        <div className="space-y-4">
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-gray-700 hover:bg-gray-800 text-white rounded-lg transition-colors duration-200 font-medium"
          >
            Go Back Home
          </button>
          
          <div className="text-sm text-gray-500">
            <button
              onClick={() => navigate(-1)}
              className="hover:text-gray-700 underline"
            >
              ← Go back to previous page
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFound